// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FX9kXT {
  font-family: var(--font-family-base);
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-background, #f9fafc);
}

.K4REpM {
  background: var(--color-surface, #fff);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.I6nbZZ {
  font-size: var(--type-title-md-font-size);
  line-height: 160%;
  color: var(--color-text, #1f1f1f);
  font-weight: 400;
  margin-bottom: 24px;
  text-align: left;
}

.wirUPN {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 16px;
}

.xNTcab {
  width: 40px;
  height: 57px;
  text-align: center;
  font-size: 24px;
  border-radius: var(--border-radius-xsmall, 4px);
  border: 1px solid var(--text-field-stroke-default, #cccccc);
  background: var(--text-field-surface, #fafafa);
}

.wR1D5o {
  margin-bottom: 16px;
  font-size: 14px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  color: var(--color-text, #1f1f1f);
}

.sVc8iu {
  background: none;
  border: none;
  color: var(--link-default, #1573d3);
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
  font-family: var(--font-family-base);
}

.sVc8iu:hover {
  opacity: 0.8;
  color: var(--color-text, #1f1f1f);
}

.fQH1pG {
  font-weight: 500;
  color: var(--color-text, #1f1f1f);
}

.gRl5a5 {
  width: 100%;
  height: 48px;
  background: var(--color-primary, #d64000);
  color: var(--submit-color, #fff);
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  margin-top: 24px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  transition: background 0.2s;
}

.gRl5a5:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.h3M4qU {
  width: 100%;
  height: 48px;
  background: transparent;
  color: var(--color-primary, #d64000);
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  transition: color 0.2s;
}

.h3M4qU:hover {
  opacity: 0.8;
}

.zse86b {
  text-align: center !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-auth/src/pages/TwoFactorVerify/TwoFactorVerify.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;EACtC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,+CAA+C;EAC/C,2DAA2D;EAC3D,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mCAAmC;EACnC,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".verifyRoot {\n  font-family: var(--font-family-base);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--color-background, #f9fafc);\n}\n\n.verifyCardWrapper {\n  background: var(--color-surface, #fff);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.verifyFormTitle {\n  font-size: var(--type-title-md-font-size);\n  line-height: 160%;\n  color: var(--color-text, #1f1f1f);\n  font-weight: 400;\n  margin-bottom: 24px;\n  text-align: left;\n}\n\n.codeInputGroup {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.codeInput {\n  width: 40px;\n  height: 57px;\n  text-align: center;\n  font-size: 24px;\n  border-radius: var(--border-radius-xsmall, 4px);\n  border: 1px solid var(--text-field-stroke-default, #cccccc);\n  background: var(--text-field-surface, #fafafa);\n}\n\n.resendMessage {\n  margin-bottom: 16px;\n  font-size: 14px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n  color: var(--color-text, #1f1f1f);\n}\n\n.resendLink {\n  background: none;\n  border: none;\n  color: var(--link-default, #1573d3);\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 14px;\n  font-family: var(--font-family-base);\n}\n\n.resendLink:hover {\n  opacity: 0.8;\n  color: var(--color-text, #1f1f1f);\n}\n\n.countdownText {\n  font-weight: 500;\n  color: var(--color-text, #1f1f1f);\n}\n\n.verifyButton {\n  width: 100%;\n  height: 48px;\n  background: var(--color-primary, #d64000);\n  color: var(--submit-color, #fff);\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 24px;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);\n  transition: background 0.2s;\n}\n\n.verifyButton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.backButton {\n  width: 100%;\n  height: 48px;\n  background: transparent;\n  color: var(--color-primary, #d64000);\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 16px;\n  cursor: pointer;\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: none;\n  transition: color 0.2s;\n}\n\n.backButton:hover {\n  opacity: 0.8;\n}\n\n.pinInput {\n  text-align: center !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"verifyRoot": `FX9kXT`,
	"verifyCardWrapper": `K4REpM`,
	"verifyFormTitle": `I6nbZZ`,
	"codeInputGroup": `wirUPN`,
	"codeInput": `xNTcab`,
	"resendMessage": `wR1D5o`,
	"resendLink": `sVc8iu`,
	"countdownText": `fQH1pG`,
	"verifyButton": `gRl5a5`,
	"backButton": `h3M4qU`,
	"pinInput": `zse86b`
};
module.exports = ___CSS_LOADER_EXPORT___;
